// src/pages/mantenimiento/Mantenimiento.jsx
import { useState } from 'react';
import styles from './estilos';
import TabTickets from './TabTickets';
import TabEquipos from './TabEquipos';
import TabPlanMensual from './TabPlanMensual';
import TabCostos from './TabCostos';
import TabKpis from './TabKpis';

export default function Mantenimiento() {
  const [tab, setTab] = useState('tickets');
  return (
    <div style={styles.paginaContenedor} className="contenedor-captura">
      <h1 style={styles.tituloPagina}>Mantenimiento</h1>
      <div style={styles.tabBar}>
        <button onClick={() => setTab('tickets')} style={{ ...styles.tabBtn, ...(tab === 'tickets' ? styles.tabBtnActivo : {}) }}>🎫 Tickets</button>
        <button onClick={() => setTab('equipos')} style={{ ...styles.tabBtn, ...(tab === 'equipos' ? styles.tabBtnActivo : {}) }}>⚙️ Equipos</button>
        <button onClick={() => setTab('plan')} style={{ ...styles.tabBtn, ...(tab === 'plan' ? styles.tabBtnActivo : {}) }}>📅 Plan Mensual</button>
        <button onClick={() => setTab('costos')} style={{ ...styles.tabBtn, ...(tab === 'costos' ? styles.tabBtnActivo : {}) }}>💰 Costos</button>
        <button onClick={() => setTab('kpis')} style={{ ...styles.tabBtn, ...(tab === 'kpis' ? styles.tabBtnActivo : {}) }}>📊 KPIs</button>
      </div>
      {tab === 'tickets' && <TabTickets />}
      {tab === 'equipos' && <TabEquipos />}
      {tab === 'plan' && <TabPlanMensual />}
      {tab === 'costos' && <TabCostos />}
      {tab === 'kpis' && <TabKpis />}
    </div>
  );
}